import { render } from "./UploadPlanilhas.vue?vue&type=template&id=c373700c&scoped=true&ts=true"
import script from "./UploadPlanilhas.vue?vue&type=script&lang=ts"
export * from "./UploadPlanilhas.vue?vue&type=script&lang=ts"

import "./UploadPlanilhas.vue?vue&type=style&index=0&id=c373700c&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c373700c"]])

export default __exports__